import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/icon-swipe.svg'


const _hoisted_1 = {
  class: "main-wrapper",
  "data-aos": "fade-up",
  "data-aos-duration": "700",
  "ata-aos-anchor-placement": "bottom-bottom"
}
const _hoisted_2 = { class: "selection-wrapper" }
const _hoisted_3 = { class: "slider-wr" }
const _hoisted_4 = { class: "info-wr" }
const _hoisted_5 = ["data-aos"]
const _hoisted_6 = { class: "floorplan-info" }
const _hoisted_7 = { class: "house-info-card" }
const _hoisted_8 = { class: "house-info-card-row" }
const _hoisted_9 = { class: "row-value" }
const _hoisted_10 = { class: "house-info-card-row" }
const _hoisted_11 = { class: "row-value" }
const _hoisted_12 = { class: "house-info-card-row" }
const _hoisted_13 = { class: "row-value" }
const _hoisted_14 = { class: "house-info-card" }
const _hoisted_15 = { class: "house-info-card-row" }
const _hoisted_16 = { class: "row-label features" }
const _hoisted_17 = ["data-aos", "src"]
const _hoisted_18 = {
  key: 1,
  class: "slider-img-wr"
}
const _hoisted_19 = ["data-aos", "src"]
const _hoisted_20 = { class: "slider-wr--controls" }
const _hoisted_21 = {
  key: 0,
  class: "swipe-icon",
  src: _imports_0
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "section-badge",
      "data-aos": "fade-down",
      "fade-down-duration": "1000"
    }, "Interactive display village", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["BuilderDemoMenuSelection"], {
            currentStep: $setup.currentStep,
            selectedImages: $setup.selectedImages,
            currentStepIndex: $setup.currentStepIndex,
            currentOptions: $setup.currentOptions,
            onChangeOption: $setup.onClickChangeOption
          }, null, 8, ["currentStep", "selectedImages", "currentStepIndex", "currentOptions"])
        ]),
        ($setup.currentStep === $setup.Steps.FLOORPLAN)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "slider-wr--floorplan-step",
              "data-aos": $setup.sliderClassAnimation
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "Floor Plan Area", -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-label" }, "Size", -1)),
                      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.selectedFloorplanData?.size) + " SQM", 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-label" }, "Width", -1)),
                      _createElementVNode("div", _hoisted_11, _toDisplayString($setup.selectedFloorplanData?.width), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "Depth", -1)),
                      _createElementVNode("div", _hoisted_13, _toDisplayString($setup.selectedFloorplanData?.depth), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Features", -1)),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedFloorplanData?.features, (feature) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(feature), 1)
                      ]))
                    }), 256))
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "floorplan-img-wr",
                ref: "sliderElement",
                onTouchstart: $setup.onTouchStart,
                onTouchend: $setup.onTouchEnd
              }, [
                _createElementVNode("img", {
                  class: "floorplan-img",
                  "data-aos": $setup.sliderClassAnimation,
                  src: require(`@/assets/images/landing/builders/builder-demo/${$setup.sliderImage}`)
                }, null, 8, _hoisted_17)
              ], 544)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        ($setup.currentStep !== $setup.Steps.FLOORPLAN && !$setup.changingSlide)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("img", {
                class: "slider-img",
                ref: "sliderElement",
                onTouchstart: $setup.onTouchStart,
                onTouchend: $setup.onTouchEnd,
                "data-once": "false",
                "data-aos": $setup.sliderClassAnimation,
                src: require(`@/assets/images/landing/builders/builder-demo/${$setup.sliderImage}`)
              }, null, 40, _hoisted_19)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          ($setup.currentStep === $setup.Steps.SELECT_DESIGN)
            ? (_openBlock(), _createElementBlock("img", _hoisted_21))
            : _createCommentVNode("", true),
          ($setup.currentStepIndex > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "controls--prev button",
                onClick: $setup.onClickPrevStep
              }, _toDisplayString(`BACK TO ${$setup.prevStep}`), 1))
            : _createCommentVNode("", true),
          (!$setup.isLastStep)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: _normalizeClass(["controls--next button", { pulsateAnimation: !$setup.isLastStep && $setup.isFirstStep }]),
                onClick: $setup.onClickNextStep
              }, "NEXT STEP", 2))
            : _createCommentVNode("", true),
          ($setup.isLastStep)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "controls--next button",
                onClick: $setup.resetSlider
              }, "START OVER"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-text-wr" }, [
      _createElementVNode("p", { class: "section-title" }, "Let our technology do the heavy lifting for you"),
      _createElementVNode("p", { class: "section-text" }, "Take prospective buyers on an immersive journey and get them excited about building their new home with you. Showcase your designs on their preferred lots and let them compare floor plans and facade options before requesting a quote. No need to quote every time, just let us know the base build price plus any standard upgrade costs (e.g. Hamptons vs Contemporary facade). Our technology will auto-calculate the variation costs before sending it to prospective buyers."),
      _createElementVNode("p", { class: "section-text" }, "Want to take buyers for a tour inside your home? Add a virtual tour or interior images to show them your finishes and colour schemes.")
    ], -1))
  ]))
}